import styles from './Loader.module.css';

export default function Loader({...rest}){
    return <div className={styles.loader_wrapper} {...rest}>
        <div className={styles.loader}></div>
    </div>;
}
